

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CardExtrinsic from '@/components/shared/CardExtrinsic.vue';
import CardEvents from '@/components/shared/CardEvents.vue';
import Connector from '@vue-polkadot/vue-api';
// import { Struct, Tuple, Raw, Vec, getTypeDef } from '@polkadot/types';

@Component({
  components: {
    CardExtrinsic,
    CardEvents,
  }
})
export default class SingleBlockExtrinsicsDetail extends Vue {
  private block: any = '';
  private decodedData: any[] = [];
  private decodedLogs: any[] = [];
  private subs: any[] = [];
  @Prop() public hash!: any;
  @Prop({default: false}) public open!: boolean;

  @Watch('$route.params.hash')
  public async loadExternalInfoByHash(hash: string) {
    const { api } = Connector.getInstance()
    this.subs.push(this.block = await api.rpc.chain.getBlock(this.hash));
  }

  @Watch('block')
  private async decode(): Promise<void> {
    if (this.block && this.block.block && this.block.block.extrinsics) {
      const { api } = Connector.getInstance()
      this.decodedData = [];
      for (const e of this.block.block.extrinsics) {
        const { meta, method, section } = await api.registry.findMetaCall(e.method.callIndex)
        this.decodedData.push({e, meta, method, section})
      }
    }
  }

  @Watch('block')
  private async decodeLogs(): Promise<void> {
    if(this.block && this.block.block 
    && this.block.block.header 
    && this.block.block.header.digest.logs) {
      const logs = this.block.block.header.digest.logs
      // console.log('SingleBlockExtrinsicsDetail -> logs', logs);
      // const decode = Object.keys(this.block.block.header.digest.logs)
      // console.log('SingleBlockExtrinsicsDetail -> decode', decode);
    }
  }

  public async mounted(): Promise<void> {
    this.loadExternalInfoByHash(this.hash)
  }
}
